<form (submit)="onSubmit($event)" [formGroup]="form" class="form-horizontal">
  <div class="card m-3">
    <div class="card-header d-flex justify-content-between align-items-baseline">
      <h3 class="card-title">Passwort ändern</h3>
      <button class="btn btn-primary" type="submit" [disabled]="!form.valid">Speichern</button>
    </div>

    <div *ngIf="isLocalUser; else nonLocalUser" class="card-body">
      <app-form-group control="oldPassword" label="Altes Passwort">
        <input
          autocomplete="off"
          id="oldPassword"
          type="password"
          placeholder="Altes Passwort"
          formControlName="oldPassword"
          class="form-control">
      </app-form-group>
      <app-form-group control="newPassword" label="Neues Passwort">
        <input
          autocomplete="off"
          id="newPassword"
          type="password"
          placeholder="Neues Passwort"
          formControlName="newPassword"
          class="form-control"
        >
        <p *ngIf="newPassword?.errors?.pattern" class="help-block">Muss mindestens einen Groß- und Kleinbuchstaben, eine Ziffer und ein Sonderzeichen enthalten. Es muss mindestens aus 12 Zeichen bestehen.</p>
      </app-form-group>
      <app-form-group control="repeatedPassword" label="Wiederholung">
        <input
          autocomplete="off"
          id="repeatedPassword"
          type="password"
          placeholder="Neues Passwort (Wiederholung)"
          formControlName="repeatedPassword"
          class="form-control"
        >
        <p *ngIf="form?.errors?.passwordMismatch" class="help-block">Passwort und Wiederholung müssen übereinstimmen.</p>
      </app-form-group>
    </div>
  </div>
  <ng-template #nonLocalUser>
    <div class="panel-body">
      <p class="form-hint">Die Authentifizierung erfolgt über einen Verzeichnisdienst. Das Passwort muss dort geändert werden.</p>
    </div>
  </ng-template>
</form>
